import { getData } from "./fetchData";

export const settingsService = {
  dajDostepneProdukty,
};

function dajDostepneProdukty() {
  return getData("konfiguracja/dostepneprodukty", {});
}
